import React, { useEffect, useState } from "react";
import { getCashBalances } from "../../utils/dataFetch";
import NewStatementModal from "./NewStatementModal";
import ReportModal from "./ReportCashflow";

export default function CashBalances() {
    const [cashBalances, setCashBalances] = useState({});
    const [selectedCashAcc, setSelectedCashAcc] = useState(null);
    const [dataError, setDataError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const [showTable, setShowTable] = useState(false);
    const toggleTable = () => setShowTable(!showTable);

    const [showExpenseModal, setShowExpenseModal] = useState(false);
    const toggleExpenseModal = (cashAcc) => {
        setSelectedCashAcc(cashAcc);
        setShowExpenseModal(!showExpenseModal);
    };

    const [showAdmissionModal, setShowAdmissionModal] = useState(false);
    const toggleAdmissionModal = (cashAcc) => {
        setSelectedCashAcc(cashAcc);
        setShowAdmissionModal(!showAdmissionModal);
    };

    const [showReport, setShowReport] = useState(false);
    const toggleReport = (cashAcc) => {
        setSelectedCashAcc(cashAcc);
        setShowReport(!showReport);
    };

    const fetchCashBalances = async () => {
        try {
            const result = await getCashBalances();
            setCashBalances(result);
            setShowTable(true);
        } catch (error) {
            setDataError("Помилка завантаження даних!");
        }
    };

    useEffect(() => {
        fetchCashBalances();
    }, []);

    return (
        <div className="col-12 col-md-auto dashboard--item flex-fill align-self-center">
            <div className="dashboard--item--container p-3 h-100">
                {successMessage && (
                    <div className="alert alert-success alert--fixed rounded-5 d-flex justify-content-between align-items-center">
                        {successMessage}
                        <button
                            type="button"
                            className="btn btn-sm btn-close"
                            aria-label="Close"
                            onClick={() => setSuccessMessage("")}
                        ></button>
                    </div>
                )}
                {errorMessage && (
                    <div className="alert alert-danger alert--fixed rounded-5 d-flex justify-content-between align-items-center">
                        {errorMessage}
                        <button
                            type="button"
                            className="btn btn-sm btn-close"
                            aria-label="Close"
                            onClick={() => setErrorMessage("")}
                        ></button>
                    </div>
                )}
                <h5 className="text-center fw-bold">Залишки коштів</h5>
                {dataError && (
                    <div className="alert alert-danger m-auto rounded-5">
                        {dataError}
                    </div>
                )}
                {!dataError && (
                    <>
                        <div className="row d-flex justify-content-around">
                            <div className="col col-auto m-0 p-0 text-center">
                                <div className="fw-light">
                                    {cashBalances.sum}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center">
                            {/* Show Table Data */}
                            <button
                                className="btn btn-sm main--button mt-3 me-1"
                                onClick={toggleTable}
                            >
                                {showTable ? "Сховати" : "Детальніше"}
                            </button>
                            {/* Show Cashflow Modal */}
                            <button
                                className="btn btn-sm main--button mt-3 ms-1"
                                onClick={toggleReport}
                            >
                                Рух коштів
                            </button>
                        </div>
                        {showTable && (
                            <div className="mt-3">
                                <div className="table-responsive rounded-4">
                                    <table className="table table-sm table-striped table-light table-hover m-0">
                                        <thead>
                                            <tr>
                                                <th
                                                    className="text-center align-middle"
                                                    scope="col"
                                                >
                                                    Назва
                                                </th>
                                                <th
                                                    className="text-center align-middle"
                                                    scope="col"
                                                >
                                                    Залишки
                                                </th>
                                                <th
                                                    className="text-center align-middle"
                                                    scope="col"
                                                >
                                                    Дії
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cashBalances.list.map(
                                                (item, index) => (
                                                    <tr key={index}>
                                                        <th
                                                            className="text-center align-middle"
                                                            scope="row"
                                                        >
                                                            {item.name}
                                                        </th>
                                                        <td className="text-center align-middle">
                                                            <span
                                                                className={`px-2 rounded-4 ${
                                                                    parseFloat(
                                                                        item.balance
                                                                    ) < 0 &&
                                                                    "bg-danger-subtle"
                                                                }`}
                                                            >
                                                                {parseFloat(
                                                                    item.balance
                                                                ).toFixed(2)}
                                                            </span>
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <button
                                                                className="btn btn-sm btn-light rounded-5 border"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <i className="bi bi-three-dots-vertical"></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() =>
                                                                            toggleReport(
                                                                                item
                                                                            )
                                                                        }
                                                                    >
                                                                        Рух
                                                                        коштів
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() =>
                                                                            toggleExpenseModal(
                                                                                item
                                                                            )
                                                                        }
                                                                    >
                                                                        Додати
                                                                        витрату
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() =>
                                                                            toggleAdmissionModal(
                                                                                item
                                                                            )
                                                                        }
                                                                    >
                                                                        Додати
                                                                        поступлення
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* Expense Modal */}
                        {showExpenseModal && (
                            <NewStatementModal
                                toggleModal={toggleExpenseModal}
                                type={"cbExpense"}
                                fetchData={fetchCashBalances}
                                setErrorMessage={setErrorMessage}
                                setSuccessMessage={setSuccessMessage}
                                selectedCashAcc={selectedCashAcc}
                            />
                        )}
                        {/* Admission Modal */}
                        {showAdmissionModal && (
                            <NewStatementModal
                                toggleModal={toggleAdmissionModal}
                                type={"cbAdmission"}
                                fetchData={fetchCashBalances}
                                setErrorMessage={setErrorMessage}
                                setSuccessMessage={setSuccessMessage}
                                selectedCashAcc={selectedCashAcc}
                            />
                        )}

                        {/* Report Modal */}
                        {showReport && (
                            <ReportModal
                                toggleModal={toggleReport}
                                selectedCashAcc={selectedCashAcc}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
